import { collections } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function CollectionSection() {
  return (
    <section id="heji" className="container-x py-10 md:py-14">
      <SectionHeading
        kicker="别处翻不到的整包 · 合集目录"
        title="爆料合集 & 黑料大全"
        desc="把零散旧帖收拢成整包：每一包都带目录、数量与归档日期，想看哪一包直接整包取，不用再到帖子里一篇篇捞。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {collections.map((c, idx) => (
          <a
            key={c.title}
            href="#shilu"
            className="group relative flex h-[420px] flex-col justify-end overflow-hidden rounded-2xl bg-background-200"
          >
            <img
              src={c.cover}
              alt={`吃瓜网爆爆料合集 · ${c.title}`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent"></div>

            <span className="absolute left-3 top-3 rounded-md bg-black/40 px-2.5 py-1 text-xs font-semibold text-white backdrop-blur">
              <i className="ri-folder-6-fill mr-1 text-accent-300"></i>
              第 {String(idx + 1).padStart(2, "0")} 包
            </span>
            <span className="absolute right-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
              {c.count}
            </span>

            <div className="relative p-4 md:p-5">
              <h3 className="font-heading text-lg font-bold leading-snug text-white">{c.title}</h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-white/75">{c.subtitle}</p>
              <div className="mt-4 flex items-center gap-2">
                <span className="text-xs text-accent-300">已归档 2026.09</span>
                <span className="ml-auto inline-flex items-center gap-1 text-sm font-semibold text-white group-hover:text-accent-300">
                  打开目录<i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}